<template>
    <app-modal :modal-id="modalId" :title="modalTitle" :preloader="preloader" @submit="submit" @close-modal="closeModal"
        modal-size="full-width">
        <template slot="header">
            <h5 class="modal-title" id="ModalLabel">{{ modalTitle }}</h5>
            <button type="button" class="close outline-none" @click.prevent="closeModal">
                <span>
                    <app-icon :name="'x'"></app-icon>
                </span>
            </button>
        </template>
        <template slot="body">
            <app-overlay-loader v-if="preloader" />
            <form class="mb-0" :class="{ 'loading-opacity': preloader }" ref="form"
                :data-url='selectedUrl ? `escorters/${inputs.id}` : `escorters`'>
                <div class="row">
                    <div class="col-md-6">
                        <!-- First Name Input -->
                        <div class="form-group">
                            <label for="first_name">{{ $t('first_name') }}
                                <span style="color: crimson">*</span>
                            </label>
                            <app-input id="first_name" type="text" v-model="inputs.first_name"
                                :placeholder="$t('first_name')" :required="true" />
                        </div>
                    </div>
                    <div class="col-md-6">
                        <!-- Last Name Input -->
                        <div class="form-group">
                            <label for="last_name">{{ $t('last_name') }}
                                <span style="color: crimson">*</span>
                            </label>
                            <app-input id="last_name" type="text" v-model="inputs.last_name"
                                :placeholder="$t('last_name')" :required="true" />
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <!-- Middle Name Input -->
                        <div class="form-group">
                            <label for="middle_name">{{ $t('middle_name') }} <span
                                    style="color: crimson">*</span></label>
                            <app-input id="middle_name" type="text" v-model="inputs.middle_name"
                                :placeholder="$t('middle_name')" :required="true" />
                        </div>
                    </div>
                    <div class="col-md-6">
                        <label for="user_date_of_birth">{{ $t('date_of_birth') }} <span
                                style="color: crimson">*</span></label>
                        <app-input id="user_date_of_birth" type="date" v-model="inputs.date_of_birth"
                            :required="true" />
                    </div>
                </div>
                <div class="row mt-4">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label>{{ $t('gender') }}</label>
                            <app-input type="radio" :list="genderList" v-model="inputs.gender" />
                        </div>
                    </div>
                    <div class="col-md-6">
                        <!-- City Input -->
                        <div class="form-group">
                            <label for="city">{{ $t('city_work') }} <span style="color: crimson">*</span></label>
                            <app-input class="w-100" id="city" v-model="inputs.city" :list="cityList"
                                :placeholder="$t('city')" type="select" :required="true" />
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <!-- Matricule Input -->
                        <div class="form-group">
                            <label for="matricule">{{ $t('matricule') }} <span style="color: crimson">*</span></label>
                            <app-input id="matricule" type="text" v-model="inputs.matricule"
                                :placeholder="$t('matricule')" :required="true" />
                        </div>
                    </div>
                    <div class="col-md-6">
                        <!-- Address Input -->
                        <div class="form-group">
                            <label for="address">{{ $t('address') }} <span style="color: crimson">*</span></label>
                            <app-input id="address" type="text" v-model="inputs.address" :placeholder="$t('address')"
                                :required="true" />
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <!-- Driver Phone Number Input -->
                        <div class="form-group">
                            <label for="phone">
                                {{ $t('personal_phone') }} <span style="color: crimson">*</span>
                            </label>
                            <app-input id="phone" type="tel-input" v-model="inputs.phone" :required="true" />
                        </div>
                    </div>
                    <div class="col-md-6">
                        <!-- Work Phone Input -->
                        <div class="form-group">
                            <label for="work_phone">{{ $t('work_phone') }}</label>
                            <app-input id="work_phone" type="tel-input" v-model="inputs.work_phone" />
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <!-- Driver IMEI Number Input -->
                        <div class="form-group">
                            <label for="imei_one">
                                {{ $t('phone_imei_one') }}
                            </label>
                            <app-input id="imei_one" type="text" v-model="inputs.imei_one"
                                :placeholder="$t('IMEI 1')" />
                        </div>
                    </div>
                    <div class="col-md-6">
                        <!-- Work IMEI 2 Input -->
                        <div class="form-group">
                            <label for="imei_two">{{ $t('phone_imei_two') }}</label>
                            <app-input id="imei_two" type="text" v-model="inputs.imei_two"
                                :placeholder="$t('IMEI 2')" />
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <!-- Category Input -->
                        <div class="form-group">
                            <label for="category">{{ $t('employee_category') }} <span
                                    style="color: crimson">*</span></label>
                            <app-input class="w-100" id="category" v-model="inputs.category" :list="categoryList"
                                :placeholder="$t('category')" type="select" :required="true" />
                        </div>
                    </div>
                    <div class="col-md-6">
                        <!-- Bank Account Input -->
                        <div class="form-group">
                            <label for="bank_account">{{ $t('bank_account') }} </label>
                            <app-input id="bank_account" type="text" v-model="inputs.bank_account"
                                :placeholder="$t('bank_account')" />
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <!-- Contact Person Input -->
                        <div class="form-group">
                            <label for="contact_person">{{ $t('contact_person') }}</label>
                            <app-input id="contact_person" type="tel-input" v-model="inputs.contact" />
                        </div>
                    </div>
                    <div class="col-md-6">
                        <!-- Marital Status Input -->
                        <div class="form-group">
                            <label for="marital_status">{{ $t('marital_tatus') }} <span
                                    style="color: crimson">*</span></label>
                            <app-input class="w-100" id="marital_status" v-model="inputs.marital_status"
                                :list="maritalStatusList" :placeholder="$t('marital_status')" type="select"
                                :required="true" />
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <!-- Comment & Observations Input -->
                        <div class="form-group">
                            <label for="comment">{{ $t('comment_observation') }}</label>
                            <app-input id="comment" type="textarea" v-model="inputs.comment"
                                :placeholder="$t('comment_observation')" :textAreaRows="5" />
                        </div>
                    </div>
                </div>
            </form>
        </template>
        <template slot="footer">
            <button type="button" class="btn btn-secondary mr-4" data-dismiss="modal" @click="closeModal">
                {{ $t('cancel') }}
            </button>
            <button type="button" class="btn btn-primary" @click="submit">{{ $t('save') }}</button>
        </template>
    </app-modal>
</template>

<script>
import { FormMixin } from '../../../../core/mixins/form/FormMixin';
import { urlGenerator } from '../../../Helpers/AxiosHelper';
import { ModalMixin } from '../../../Mixins/ModalMixin';

export default {
    name: 'EscorterAddEditModal',
    mixins: [FormMixin, ModalMixin],
    props: {
        tableId: {
            type: String,
        },
    },
    computed: {

    },
    data() {
        return {
            preloader: false,
            modalId: 'escorter-add-edit-modal',
            inputs: {
                job_title: '-'
            },
            cityList: [
                { id: '', value: this.$t('choose_one') },
                { id: 'kolwezi', value: 'Kolwezi' },
                { id: 'likasi', value: 'Likasi' },
                { id: 'lubumbashi', value: 'Lubumbashi' },
                { id: 'kasumbalesa', value: 'Kasumbalesa' },
                { id: 'mokambo', value: 'Mokambo' },
                { id: 'sakania', value: 'Sakania' },
                { id: 'ndola', value: 'Ndola' },
            ],
            categoryList: [
                { id: '', value: this.$t('choose_one') },
                { id: 'team_leader', value: this.$t('team_leader') },
                { id: 'commander', value: this.$t('commander') },
                { id: 'supervisor', value: this.$t('supervisor') },
                { id: 'checkpoint', value: this.$t('checkpoint') },
                { id: 'transporter', value: this.$t('transporter') },
                { id: 'loader', value: this.$t('loader') },
                { id: 'guard', value: this.$t('guard') },
                { id: 'control', value: this.$t('control') },
            ],
            maritalStatusList: [
                { id: '', value: this.$t('choose_one') },
                { id: 'single', value: this.$t('single') },
                { id: 'married', value: this.$t('married') },
                { id: 'divorced', value: this.$t('divorced') },
            ],
            genderList: [
                {
                    id: 'male',
                    value: this.$t('male')
                },
                {
                    id: 'female',
                    value: this.$t('female')
                }
            ],
            isModalActive: false,
            modalTitle: `${this.$t('new_escorter')}`,
        }
    },
    methods: {
        submit() {
            if (this.inputs.date_of_birth != null) {
                this.inputs.date_of_birth = moment(this.inputs.date_of_birth).format('YYYY-MM-DD');
            }
            this.save(this.inputs);
            this.$hub.$emit('reload-' + this.tableId);
        },

        afterSuccess(response) {
            this.$toastr.s(response.data.message);
            const escorterId = response.data.escorter.id;
            window.location = urlGenerator(`escorters/${escorterId}/details`);
        },

        afterSuccessFromGetEditData(response) {
            this.inputs = response.data;
            this.preloader = false;
        },
    },
    created() {
        if (this.selectedUrl) {
            this.modalTitle = this.$t('edit');
            this.preloader = true;
        }
    },
}
</script>

<style>

</style>